var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("line",{"x1":"0.5","y1":"0.5","x2":"9.5","y2":"0.5","stroke":"white","strokeLinecap":"round"}));
}

Minus.defaultProps = {"width":"10","height":"1","viewBox":"0 0 10 1","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
